<!--
只支持一个表单项，但支持描述，和api验证该项是否正确
只读模块

使用3
  const value = await this.$inputDialog({
    title: "关联活动",
    type: "text",
    desc: "",
    label: "活动名称",
    placeholder: "",
    value: row.activityName,
    confirmText: "提交",
    rules: [{ required: false, message: "" }],
    verify: {
      desc: "活动id：",
      resName: "activityId",
      api: "",
      req: (value) => {
        return { a: value };
      },
    },
  });
使用2
  const value = await this.$inputDialog({
    title: "关联活动",
    type: "text",
    desc: "",
    label: "活动名称",
    verifyResult: `活动名称${row.activityId}`,
    disabled: true,
    placeholder: "",
    value: row.activityName,
    cancelText: "关闭",
    confirmText: "编辑",
    rules: [{ required: false, message: "" }],
  });
使用1
try {
  const value = await this.$inputDialog({
    title: "关闭需求",
    desc: "关闭需求后无法恢复，请谨慎操作！",
    label: "关闭原因（需求提出者可见）",
    type: "textarea",
    placeholder: "请输入数量",
    numberMax: 9999999999,
    value: value,
    options: [
      { label: "北京", value: "beijing" },
      { label: "上海", value: "shanghai" },
      { label: "广州", value: "guangzhou" },
      { label: "深圳", value: "shenzhen" },
      { label: "杭州", value: "hangzhou" },
    ],
    rules: [{ required: true, message: "请选择一个城市" }],
  });

  console.log(value);
  this.result = `选择结果: ${value}`;
} catch (error) {
  console.log(error.message);
  this.result = `用户取消输入: ${error.message}`;
}
-->
<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" :width="width" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="input-dialog">
    <div class="desc">{{ desc }}</div>
    <el-form :model="form" label-width="auto">
      <el-form-item :label="label" :error="error" :required="isRequired">
        <!-- 文本输入 -->
        <template v-if="type === 'text' && !multiline">
          <el-input v-model="form.value" :placeholder="placeholder" @keyup.enter.native="handleConfirm" @blur="inputBlur" :autofocus="true" clearable :disabled="disabled" :maxlength="maxlength" :show-word-limit="showWordLimit"></el-input>

          <div class="verify" v-if="verifyResult">{{ verifyResult }}</div>
          <div v-if="verify && verify.showResField" class="verify">{{ verify.desc }}：{{ res[showResField] }}</div>
        </template>
        <!-- 多行文本输入 -->
        <el-input v-else-if="type === 'textarea' || multiline" type="textarea" :rows="rows" v-model="form.value" :placeholder="placeholder" clearable></el-input>

        <!-- 数字输入 -->
        <el-input-number v-else-if="type === 'number'" v-model="form.value" :placeholder="placeholder" :maxlength="maxlength" :min="numberMin" :max="numberMax" :step="numberStep" controls-position="right" style="width: 100%"></el-input-number>

        <!-- 下拉选择 -->
        <el-select v-else-if="type === 'select'" v-model="form.value" :placeholder="placeholder" style="width: 100%" filterable :clearable="clearable">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel" :disabled="loading">{{ cancelText }}</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="loading" :disabled="!form.value && isRequired">{{ confirmText }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
  export default {
    name: "InputDialog",
    props: {
      title: {
        type: String,
        default: "请输入",
      },
      type: {
        type: String,
        default: "text",
        validator: (value) => ["text", "textarea", "number", "select"].includes(value),
      },
      verifyResult: {
        type: String,
        default: null,
      },
      label: {
        type: String,
        default: "内容",
      },
      value: {
        type: [String, Number, Array, Object],
        default: "",
      },
      placeholder: {
        type: String,
        default: "请输入内容",
      },
      desc: {
        type: String,
        default: "",
      },
      confirmText: {
        type: String,
        default: "确定",
      },
      cancelText: {
        type: String,
        default: "取消",
      },
      // 是否显示字数统计（Element UI原生功能）
      showWordLimit: {
        type: Boolean,
        default: false,
      },
      clearable: {
        type: Boolean,
        default: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      maxlength: {
        type: Number,
        default: null,
      },
      rules: {
        type: Array,
        default: () => [],
      },
      verify: {
        type: Object,
        default: () => ({
          /*
            label: "活动id",
            showResField: "activityId",
            api: "",
            req: (value) => {
              return { a: value };
            },
          */
        }),
      },
      options: {
        type: Array,
        default: () => [],
      },
      multiline: {
        type: Boolean,
        default: false,
      },
      rows: {
        type: Number,
        default: 4,
      },
      width: {
        type: String,
        default: "500px",
      },
      numberMin: {
        type: Number,
        default: -Infinity,
      },
      numberMax: {
        type: Number,
        default: Infinity,
      },
      numberStep: {
        type: Number,
        default: 1,
      },
    },
    data() {
      return {
        res: {},
        dialogVisible: false,
        form: {
          value: this.value || "3",
        },
        loading: false,
        error: "",
        resolve: null,
        reject: null,
      };
    },
    computed: {
      isRequired() {
        return this.rules.some((rule) => rule.required);
      },
    },
    watch: {
      value: {
        handler(newVal) {
          console.log("newVal", newVal);
          this.form.value = newVal;
        },
        deep: true,
        immediate: true,
      },
      "form.value"() {
        this.error = "";
      },
    },
    create() {
      if (this.value && this.verify?.resName) {
        this.doVerify();
      }
    },
    methods: {
      open() {
        console.log("this.value", this.value);
        this.dialogVisible = true;
        this.form.value = this.value;
        this.error = "";
        this.loading = false;
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      },

      inputBlur() {
        this.doVerify();
      },

      async doVerify() {
        if (this.verify.api) {
          const params = this.verify.req(this.form.value);
          const res = await this.verify.api(params);
          if (res.status === 200) {
            this.res = res.data;
          } else {
            console.log("验证出错了", res);
          }
        }
      },

      handleConfirm() {
        // 验证输入
        if (this.rules.length > 0) {
          const validationError = this.validateInput(this.form.value);
          if (validationError) {
            this.error = validationError;
            return;
          }
        }

        this.loading = true;

        setTimeout(() => {
          this.loading = false;
          this.dialogVisible = false;
          if (this.resolve) {
            console.log(111);
            this.resolve(this.form.value);
          }
        }, 0);
      },

      handleCancel() {
        this.dialogVisible = false;
        if (this.reject) {
          this.reject(new Error("用户取消输入"));
        }
      },

      validateInput(value) {
        for (const rule of this.rules) {
          if (rule.required && (value === "" || value === null || value === undefined)) {
            return rule.message || "该项为必填项";
          }

          if (rule.pattern && !rule.pattern.test(value)) {
            return rule.message || "格式不正确";
          }

          if (rule.validator && typeof rule.validator === "function") {
            const result = rule.validator(value);
            if (result !== true) {
              return result || "验证失败";
            }
          }

          if (rule.min !== undefined && value < rule.min) {
            return rule.message || `值不能小于 ${rule.min}`;
          }

          if (rule.max !== undefined && value > rule.max) {
            return rule.message || `值不能大于 ${rule.max}`;
          }
        }

        return "";
      },
    },
  };
</script>

<style lang="less">
  .input-dialog {
    border-radius: 12px;

    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #eee;

      .el-dialog__title {
        color: #333;
        font-size: 18px;
        font-weight: 600;
      }
    }

    .el-dialog__body {
      padding: 20px;
    }

    .el-dialog__footer {
      padding: 15px 20px;
      border-top: 1px solid #eee;
    }

    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
    }
  }
</style>
